const shaka = require("shaka-player/dist/shaka-player.ui")
export default class SwapButton extends shaka.ui.Element {
  constructor(
    parent: any,
    controls: any,
    swapPlayers: Function,
    basePlayer: any,
    pipPlayer: any
  ) {
    super(parent, controls)
    // The actual button that will be displayed
    this.button_ = document.createElement("button")
    this.button_.classList.add("shaka-caption-button")
    this.button_.classList.add("material-icons")
    this.button_.setAttribute("aria-label", "Swap Screens")
    this.button_.textContent = "swap_horiz"
    this.parent.appendChild(this.button_)
    // Listen for clicks on the button to start captions
    this.eventManager.listen(this.button_, "click", () => {
      swapPlayers(basePlayer, pipPlayer)
    })
  }
}
